import './index.scss'
import fastForwardHtml from './index.html'
import { parseDom } from 'src/frontend-lib/tools/domUtil'

/**
 * 快进快退组件
 */
export default class FastForwardComponent {
  constructor(postTime) {
    this.html = parseDom(fastForwardHtml)
    this.timeId = null
    this.postTime = postTime
  }

  createEl(el, player) {
    let eleControlbar = el.querySelector('.prism-controlbar')
    eleControlbar.appendChild(this.html)
    // el.appendChild(this.html)
  }

  created(player) {
    // console.log('=== FastForwardComponent === created')
    let forwardLeftEle = this.html.querySelector('.forward-left')
    let forwardRightEle = this.html.querySelector('.forward-right')

    forwardLeftEle.onclick = ({ target }) => {
      let currentTime = player.getCurrentTime()
      if (currentTime > 30) {
        player.seek(currentTime - 30)
      } else {
        player.seek(0)
      }
      this.postTime.apply(player)
    }

    forwardRightEle.onclick = ({ target }) => {
      let durationTime = player.getDuration()
      let currentTime = player.getCurrentTime()
      if (durationTime - currentTime > 30) {
        player.seek(currentTime + 30)
      } else {
        player.seek(durationTime)
      }
      this.postTime.apply(player)
    }
  }

  hideComponent() {
    let self = this
    this.timeId = window.setTimeout(() => {
      self.html.style.display = 'none'
      window.clearTimeout(self.timeId)
    }, 1000)
    // this.html.style.display = 'none'
  }

  visibleComponent() {
    console.log('=== visibleComponent === this', this)
    window.clearTimeout(this.timeId)
    this.html.style.display = 'flex'
  }
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/FastForwardComponent/index.js